import { ActionReducer, createFeatureSelector, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import { SparePartActions } from '../actions';

export enum ReorderStatus {
  DEFAULT = 'default',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  COMPLETED = 'completed',
  CANCELED = 'canceled'
}

export interface SparePartState {
  items: any[];
  status: ReorderStatus;
}

export const initialState: SparePartState = {
  items: [],
  status: ReorderStatus.DEFAULT
};

export const sparePartStoreName: string = 'sparePart';

const getSparePartFeatureState: MemoizedSelector<object, SparePartState> = createFeatureSelector<SparePartState>(sparePartStoreName);

export const getReorderState: MemoizedSelector<object, SparePartState> = createSelector(
  getSparePartFeatureState,
  state => state,
);

export const getReorderItems: MemoizedSelector<object, any[]> = createSelector(
  getSparePartFeatureState,
  state => state.items,
);

export const isReorderPending: MemoizedSelector<object, boolean> = createSelector(
  getSparePartFeatureState,
  state => state.status === ReorderStatus.PENDING,
);

export const isReorderConfirmed: MemoizedSelector<object, boolean> = createSelector(
  getSparePartFeatureState,
  state => state.status === ReorderStatus.CONFIRMED,
);

export const SparePartReducer: ActionReducer<SparePartState> = createReducer(
  initialState,
  on(SparePartActions.addItem, (state, {item}) => {
    return {
      ...state,
      items: [item],
      status: ReorderStatus.PENDING
    };
  }),
  on(SparePartActions.addAllItems, (state, {items}) => {
    return {
      ...state,
      items: items,
      status: ReorderStatus.PENDING
    };
  }),
  on(SparePartActions.updateReorderWithSystemDetails, (state, {updatedSystemDetails}) => {
    return {
      ...state,
      items: state.items.map(item => {
        return {
          ...item,
          data: {
            ...item.data,
            systemDetails: updatedSystemDetails,
            systemDetailsPerItem: [{
              itemId: item.data.sku,
              systemDetails: updatedSystemDetails
            }]
          }
        };
      }),
      status: ReorderStatus.PENDING
    };
  }),
  on(SparePartActions.confirmReorder, (state) => {
    return {
      ...state,
      items: state.items,
      status: ReorderStatus.CONFIRMED
    };
  }),
  on(SparePartActions.completeReorder, (state) => {
    return {
      ...state,
      items: [],
      status: ReorderStatus.COMPLETED
    };
  }),
  on(SparePartActions.cancelReorder, (state) => {
    return {
      ...state,
      items: [],
      status: ReorderStatus.CANCELED
    };
  }),
);
